/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import Box from '@mui/material/Box';
import AutocompleteSelect from '../common/selects/AutocompleteSelect';
import { ChartExportType } from './DataUsageExport/DataUsageExportUtils';
export interface DataUsageChartsSelectorProps {
  onSelectboxValueChanged: (values: string[]) => void;
}
function DataUsageChartsSelector({ onSelectboxValueChanged }: DataUsageChartsSelectorProps) {
  return (
    <Box sx={{ width: '320px', position: 'relative', marginLeft: '21px' }}>
      <AutocompleteSelect<string>
        onSelectboxValueChanged={onSelectboxValueChanged}
        getOptionLabel={(label: string) => label}
        isOptionEqualToValue={(option: string, value: string) => {
          return option === value;
        }}
        options={
          [
            'Link Usage',
            'Link Usage (cumulative)',
            'Link Usage (comparison)',
            'Network Usage',
            'Network Usage (cumulative)',
            'Network Usage (comparison)',
            'Performance Summary',
            'Service Availability',
          ] as ChartExportType[]
        }
        placeholderText="Select Report(s)"
        multipleSelectedText="Multiple reports selected"
        selectAllByDefault={true}
      />
    </Box>
  );
}

export default DataUsageChartsSelector;
